import { config } from '@uhg-abyss/web/tools/config';
import { http } from '@uhg-abyss/web/tools/http';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';
import { registrationStatusError } from './errors';

export const registrationStatus = async (payload) => {
  const { action } = payload;
  const { billingTin, requestId, trackingNumber, isSuperUser, isAllSelected } =
    action.payload;
  const response = await http({
    id: 'epv-tin-info',
    method: 'GET',
    cache: false,
    withCredentials: true,
    url: `${config('LINK_EPV_API_URL')}/tin/v1`,
    handleError: registrationStatusError,
    query: {
      billingTin,
      requestId,
      trackingNumber,
      isSuperUser,
      isAllSelected,
    },
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};
